import { useAtom, useSetAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";

export const darkModeAtom = atomWithStorage("darkMode", false);
const useDarkMode = () => {
  const atom = useAtom(darkModeAtom);
  return atom;
};

export const useSetDarkMode = () => useSetAtom(darkModeAtom);

export default useDarkMode;
